import React, { useState } from "react";
import styled from "styled-components";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; // Import icons

const BulletinList = ({ bulletins, onDelete, isAuthenticated }) => {
    const [currentPage, setCurrentPage] = useState(1); // Current page state
    const bulletinsPerPage = 3; // Bulletins per page

    // Calculate bulletins for the current page
    const indexOfLastBulletin = currentPage * bulletinsPerPage;
    const indexOfFirstBulletin = indexOfLastBulletin - bulletinsPerPage;
    const currentBulletins = bulletins.slice(indexOfFirstBulletin, indexOfLastBulletin);

    // Pagination handlers
    const goToNextPage = () => {
        if (currentPage < Math.ceil(bulletins.length / bulletinsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <BulletinContainer>
            {currentBulletins.map((bulletin) => (
                <BulletinItem key={bulletin.id}>
                    <BulletinHeader>
                        {/* <strong>{bulletin.user || 'Unknown User'}</strong> - {bulletin.created_at ? new Date(bulletin.created_at).toLocaleString('zh-TW', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) : 'Unknown Time'} */}
                        <strong>{bulletin.user || 'Unknown User'}</strong> - 
                        {bulletin.created_at ? new Date(bulletin.created_at).toLocaleString('zh-TW', { 
                            year: 'numeric', 
                            month: '2-digit', 
                            day: '2-digit', 
                            hour: '2-digit', 
                            minute: '2-digit' 
                        }) : 'Unknown Time'}
                    </BulletinHeader>
                    <BulletinContent>{bulletin.content}</BulletinContent>
                    {isAuthenticated && (
                        <DeleteButton onClick={() => onDelete(bulletin.id)}>
                            Delete
                        </DeleteButton>
                    )}
                </BulletinItem>
            ))}

            {/* Pagination Controls */}
            <PaginationContainer>
                <PageButton onClick={goToPreviousPage} disabled={currentPage === 1}>
                    <FaArrowLeft /> {/* Left arrow icon */}
                </PageButton>
                <PageInfo>Page {currentPage} of {Math.ceil(bulletins.length / bulletinsPerPage)}</PageInfo>
                <PageButton onClick={goToNextPage} disabled={currentPage === Math.ceil(bulletins.length / bulletinsPerPage)}>
                    <FaArrowRight /> {/* Right arrow icon */}
                </PageButton>
            </PaginationContainer>
        </BulletinContainer>
    );
};

export default BulletinList;

// Styled Components
const BulletinContainer = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
    width: 90%;
    max-width: 800px;
    margin: auto;
`;

const BulletinItem = styled.li`
    margin-bottom: 15px;
    padding: 15px;
    border: 1px solid var(--app-border, #ddd);
    border-radius: 8px;
    background-color: var(--app-surface, #f9f9f9);
    color: var(--app-surface-text, #202124);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s;
`;

const BulletinHeader = styled.p`
    font-size: 0.95rem;
    color: var(--app-subtle-text, #333);
    margin: 0 0 5px;
`;

const BulletinContent = styled.p`
    font-size: 0.85rem;
    color: var(--app-muted-text, #555);
    margin: 0 0 10px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
`;

const DeleteButton = styled.button`
    color: red;
    cursor: pointer;
    font-size: 0.8rem;
    background: none;
    border: none;
    outline: none;
    padding: 5px;
    transition: color 0.3s;

    &:hover {
        color: #d00;
    }
`;

// Pagination Styles
const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
`;

const PageButton = styled.button`
    font-size: 1.2rem;
    padding: 5px;
    margin: 0 5px;
    cursor: pointer;
    border: none;
    background: none;
    color: var(--app-text, #333);
    transition: color 0.3s;

    &:hover {
        color: var(--app-muted-text, #555);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;

const PageInfo = styled.span`
    font-size: 0.9rem;
    color: var(--app-text, #333);
`;
